import React, { useState, useRef, useEffect, useContext } from 'react'

import "../../../CssFiles/moreDetails.css"
import safetyIcon from '../../../Images/bureauImages/safetyIcon.png'
import rupeeIcon from '../../../Images/helloTradeImages/RupeeIcon.png'
import logo from '../../../Images/helloTradeImages/HelloTradeLogo.png'
import { gatrack } from "../../../utils"

import {writeAddInfo, getUserSession, writeLogs, getCurrentIST} from '../../../utils'

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { BureauContext } from '../../Pages/HelloTradePage';

function MoreDetailsComponent() {
    const [formData, setFormData] = useState({
        udyamRegNo: "",
        gstRegNo: "",
        businessAddress: "",
        businessPinCode: "",
        businessOwnership: "",
        residenceAddress: "",
        residencePinCode: "",
        residenceOwnership: "",
    });

    const {moreInfo, userInfo, setDisplayPage} = useContext(BureauContext);

    const [errors, setErrors] = useState({});

    const validateGSTNumber = (gstNumber) => {
        const gstRegex = /^[a-zA-Z0-9]{15}$/;
        if (!gstNumber) {
            return "GST Registration Number is required";
        } else if (!gstRegex.test(gstNumber)) {
            return "GST Number must be 15 alphanumeric characters";
        }
        return "";
    };

    const validateUdyamNumber = (udyamNumber) => {
        const udyamRegex = /^[a-zA-Z0-9]{19}$/;
        if (!udyamNumber) {
            return "Udyam Registration Number is required";
        } else if (!udyamRegex.test(udyamNumber)) {
            return "Udyam Number must be 19 alphanumeric characters";
        }
        return "";
    };

    const validateAddress = (address) => {
        if (!address) {
            return "Business Address is required";
        } else if (address.length < 5) {
            return "Business Address must be at least 5 characters long";
        } else if (address.length > 300) {
            return "Business Address must not exceed 300 characters";
        }
        return "";
    };

    const validatePincode = (pin) => {
        if (!pin) {
            return "Business Pin Code is required";
        } else if (!/^\d{6}$/.test(pin)) {
            return "Business Pin Code must be exactly 6 digits";
        }
        return "";
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        if (name == "gstRegNo" || name == "udyamRegNo") {
            value = value.toUpperCase();
        }
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.gstRegNo) newErrors.gstRegNo = "GST Registration Number is required";
        else {
            const gstError = validateGSTNumber(formData.gstRegNo);
            if (gstError) newErrors.gstRegNo = gstError;
        }

        if (!formData.businessAddress) newErrors.businessAddress = "Business Address is required";
        else {
            const bissError = validateAddress(formData.businessAddress);
            if (bissError) newErrors.businessAddress = bissError;
        }

        if (!formData.businessPinCode) newErrors.businessPinCode = "Business Pin Code is required";
        else {
            const pinError = validatePincode(formData.businessPinCode);
            if (pinError) newErrors.businessPinCode = pinError;
        }

        if (!formData.businessOwnership) newErrors.businessOwnership = "Business Premises Ownership is required";

        if (!formData.residenceAddress) newErrors.residenceAddress = "Residence Address is required";
        else {
            const resError = validateAddress(formData.residenceAddress);
            if (resError) newErrors.residenceAddress = resError;
        }

        if (!formData.residencePinCode) newErrors.residencePinCode = "Residence Pin Code is required";
        else {
            const pinError = validatePincode(formData.residencePinCode);
            if (pinError) newErrors.residencePinCode = pinError;
        }

        if (!formData.residenceOwnership) newErrors.residenceOwnership = "Residence Premises Ownership is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        let time = getCurrentIST();
        if (validateForm()) {
            //console.log("Form Data Submitted:", formData);            
            let resp = await writeAddInfo(formData.gstRegNo, formData.udyamRegNo, formData.businessAddress, formData.businessPinCode, formData.businessOwnership, formData.residenceAddress, formData.residencePinCode, formData.residenceOwnership, userInfo.glid, userInfo.ak)
            console.log("resp => ", resp);
            if (resp == "success") {
                gatrack("HT Journey", "Additional Info Submit", "Additional Page", userInfo.glid)

                writeLogs(userInfo.glid, `Additional Info`, "SUCCESS", "CLICK", "Submit CTA", "200", "NA", time, time, 0)
                setDisplayPage(4)
            } else {
                gatrack("HT Journey", "Error in Additional Info Submit", "Additional Page", userInfo.glid)
                writeLogs(userInfo.glid, `Additional Info`, "Error in Additional Info Submit", "CLICK", "Submit CTA", "400", "NA", time, time, 0)
            }
        } else {
            gatrack("HT Journey", "Invalid Additional Info Submit", "Additional Page", userInfo.glid)
            writeLogs(userInfo.glid, `Invalid Additional Info Submit`, "All data not entered", "CLICK", "Submit CTA", "204", "NA", time, time, 0)
        }
    };

    const prefillData = ()=>{
        let userData = moreInfo;
        setFormData({ ...formData, ["gstRegNo"]: userData.gst, ["businessAddress"]:userData.bisAdd, ["businessPinCode"]:userData.bisPin });
    }

    useEffect(() => {
        console.log("hii")
        prefillData();
    }, [moreInfo]);
    



    return (
        <>
            <div id='pi-parent'>
                <div className='pi'>
                    <div className='pi-header'>
                        {/* <span id='back-arrow-parent'><img src={backArrow} style={{ width: '16px' }} /></span> */}
                        {/* <span id='header-text'>Let's Get Your CIBIL</span> */}
                        {/* <div className='header logo bureauHeader'>
                            <img src={rupeeIcon} id="rupeeIcon" />
                            <img src={logo} id="logoIcon" />
                        </div> */}
                        <span id='header-text'>You're nearly there</span>
                        <div className='no-affect'>(Just a few more additional details required)</div>
                    </div>

                    <div className="progress-bar">
                        <div className="progress-indicator"></div>
                    </div>



                    <div className="detailed-form container mt-4">
                        {/* GST and Udyam Registration Row */}
                        <div className="row mb-3 top-row">
                            <div className="col-md-6 mb-3">
                                <div className="input-parent">
                                    <label>GST No.</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.gstRegNo ? "is-invalid" : ""}`}
                                        name="gstRegNo"
                                        value={formData.gstRegNo}
                                        onChange={handleInputChange}
                                        placeholder="Enter GST Registration No."
                                        maxLength={15}
                                    />
                                    {errors.gstRegNo && <div className="invalid-feedback">{errors.gstRegNo}</div>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-parent">
                                    <label>Udyam No.</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="udyamRegNo"
                                        value={formData.udyamRegNo}
                                        onChange={handleInputChange}
                                        placeholder="Enter Udyam Registration No."
                                        maxLength={19}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Business and Residential Address Details */}
                        <div className="row">
                            {/* Business Address Details */}
                            <div className="col-md-6">
                                <h6 className='addr-heading'>Business Address Details</h6>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Business Address</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.businessAddress ? "is-invalid" : ""}`}
                                            name="businessAddress"
                                            value={formData.businessAddress}
                                            onChange={handleInputChange}
                                            placeholder="Enter Business Address"
                                        />
                                        {errors.businessAddress && (
                                            <div className="invalid-feedback">{errors.businessAddress}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Business Pincode</label>
                                        <input
                                            type="number"
                                            className={`form-control ${errors.businessPinCode ? "is-invalid" : ""}`}
                                            name="businessPinCode"
                                            maxLength={6}
                                            value={formData.businessPinCode}
                                            onChange={handleInputChange}
                                            onInput={(e) => {
                                                if (/e|E/.test(e.nativeEvent.data)) {
                                                    e.target.value = e.target.value.slice(0, -1);
                                                }
                                                if (e.target.value.length > 6) {
                                                    e.target.value = e.target.value.slice(0, 6);
                                                }
                                            }}
                                            placeholder="Enter Business Pin Code"
                                        />
                                        {errors.businessPinCode && (
                                            <div className="invalid-feedback">{errors.businessPinCode}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Business Premises Ownership</label>
                                        <div className="custom-select-wrapper">
                                            <select
                                                className={`form-control ${errors.businessOwnership ? "is-invalid" : ""}`}
                                                name="businessOwnership"
                                                value={formData.businessOwnership}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Ownership</option>
                                                <option value="Self Owned">Self Owned</option>
                                                <option value="Rented">Rented</option>
                                                <option value="Family Owned">Family Owned</option>
                                            </select>
                                            <i className="bi bi-chevron-down custom-icon"></i>
                                        </div>
                                        {errors.businessOwnership && (
                                            <div className="invalid-feedback">{errors.businessOwnership}</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Residential Address Details */}
                            <div className="col-md-6">
                                <h6 className='addr-heading'>Residential Address Details</h6>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Residence Address</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.residenceAddress ? "is-invalid" : ""}`}
                                            name="residenceAddress"
                                            value={formData.residenceAddress}
                                            onChange={handleInputChange}
                                            placeholder="Enter Residence Address"
                                        />
                                        {errors.residenceAddress && (
                                            <div className="invalid-feedback">{errors.residenceAddress}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Residence Pincode</label>
                                        <input
                                            type="number"
                                            className={`form-control ${errors.residencePinCode ? "is-invalid" : ""}`}
                                            name="residencePinCode"
                                            value={formData.residencePinCode}
                                            onInput={(e) => {
                                                if (/e|E/.test(e.nativeEvent.data)) {
                                                    e.target.value = e.target.value.slice(0, -1);
                                                }
                                                if (e.target.value.length > 6) {
                                                    e.target.value = e.target.value.slice(0, 6);
                                                }
                                            }}
                                            onChange={handleInputChange}
                                            placeholder="Enter Residence Pin Code"
                                            maxLength={6}
                                        />
                                        {errors.residencePinCode && (
                                            <div className="invalid-feedback">{errors.residencePinCode}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="input-parent">
                                        <label>Residence Premises Ownership</label>
                                        <div className="custom-select-wrapper">
                                            <select
                                                className={`form-control ${errors.residenceOwnership ? "is-invalid" : ""}`}
                                                name="residenceOwnership"
                                                value={formData.residenceOwnership}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Ownership</option>
                                                <option value="Self Owned">Self Owned</option>
                                                <option value="Rented">Rented</option>
                                                <option value="Family Owned">Family Owned</option>
                                            </select>
                                            <i className="bi bi-chevron-down custom-icon"></i>
                                            {errors.residenceOwnership && (
                                                <div className="invalid-feedback">{errors.residenceOwnership}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="mt-4 text-center">
                            <div className="getOffer-btn" onClick={handleSubmit}>
                                Submit
                            </div>
                        </div>
                    </div>




                    <div className='safety'>
                        <img src={safetyIcon} />
                        <div id='safety-text'>Your data is 100% safe & secure</div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default MoreDetailsComponent




// < label > Datee of Birth *</label >
//     <div style={{ display: 'flex' }} className="form-control">
//         <DatePicker
//             ref={datePickerRef}
//             selected={formData.dob}
//             onChange={handleDobChange}
//             dateFormat="dd-MM-yyyy"
//             showMonthDropdown
//             showYearDropdown
//             scrollableYearDropdown
//             yearDropdownItemNumber={100}
//             maxDate={new Date()}
//             minDate={new Date(1930, 0, 1)}
//             customInput={
//                 <input
//                     type="text"
//                     name="dob"
//                     value={formData.dob ? formData.dob.toLocaleDateString('en-GB') : ''}
//                     readOnly
//                     onClick={handleCalendarClick}
//                     onChange={handleInputChange}
//                 />
//             }
//         />
//         <div>
//             <i
//                 className="bi bi-calendar3"
//                 onClick={handleCalendarClick}
//             />
//         </div>
//     </div>
